export const UtmCampaigns = {
    SoloCourseV1: 'solo_course_v1',
    Grow30: 'grow_30'
} as const;

export type TUtmCampaign = (typeof UtmCampaigns)[keyof typeof UtmCampaigns];
